import { AdminRegistrationForm } from "./AdminRegistrationForm";

export const AdminRegistration = () => {
  return <AdminRegistrationForm />;
};
